import type { VideoCall } from "@/types";
import { releaseEndedOrderForManualAnchorHangup } from "./anchorOrderRelease";
import { callApi } from "./callApi";
import { shengwangClient } from "./shengwangClient";

export async function releaseThenLeaveForAnchorHangup(call: VideoCall) {
  if (call.order_id) {
    await releaseEndedOrderForManualAnchorHangup(call.order_id);
  } else if (call.call_id) {
    await callApi.endCall(call.call_id);
  } else {
    throw new Error("Missing call identifier");
  }
  await shengwangClient.leaveCall();
}
